import $ from 'jquery';
const materialSelectionHandling = () =>{
    $(".materialBasket").detach().prependTo('form[id^="addressForm_kundenclubBestellung"]');

    const materialArr: {materialTitle: string, materialNumber: string, materialAmount: number}[] = []
    $('.catalogue-form-amount').on('change', function(){
        var materialCard = $(this).closest('.catalogue-box');
        var materialID = ($(materialCard).prop('id').split('_'))[1];
        var materialTitle = $('.catalogue-box-title', materialCard).html();
        var materialNumber = '-';
        if($('.catalogue-box-artno', materialCard).length)
            materialNumber = $('.catalogue-box-artno', materialCard).html();
        var materialAmount = parseInt($(this).val()?.toString() || '0');

        if(materialAmount > 0) {
            materialArr[materialID] = {
                'materialTitle': materialTitle,
                'materialNumber': materialNumber,
                'materialAmount': materialAmount,
            }
        } else {
            delete materialArr[materialID];
        }

        $('.materialBasketTable').html('');

        if(Object.keys(materialArr).length) {
            $(".materialBasket").show();
        } else {
            $(".materialBasket").hide();
        }

        materialArr.forEach(item => {
            if (item.materialAmount > 0) {
                var trTitle = $('.rowTitle', '.materialBasket .rowProto').clone();
                var trArtNo = $('.rowArtNo', '.materialBasket .rowProto').clone();
                var trAmount = $('.rowAmount', '.materialBasket .rowProto').clone();
                $('.tdTitle', trTitle).html(item['materialTitle']);
                $('.tdArtNo', trArtNo).html(item['materialNumber']);
                $('.tdAmount', trAmount).html(item['materialAmount'].toString());
                $('.materialBasketTable', '.materialBasket').append(trTitle);
                $('.materialBasketTable', '.materialBasket').append(trArtNo);
                $('.materialBasketTable', '.materialBasket').append(trAmount);
                $('.materialBasketTable', '.materialBasket').append('<br>');
            }
        });
        $('input[id^="addressForm_kundenclubBestellung"][id$="hidden-1"]').val(JSON.stringify(materialArr.filter(item => { return item && item.materialAmount > 0})));
    });
}

const descriptionOverflowHandling = () => {
    $('.material-box-description').each(function(){
        if(isOverflown(this)){
            $(this).closest('.catalogue-box-content').children('.material-box-description-more').show();
        }
    });
    $('.material-box-description-more').on('click', function(){
        if(!$(this).siblings('.material-box-description').hasClass('material-box-description-big')){
            $(this).siblings('.material-box-description').addClass('material-box-description-big');
            var curHeight = $(this).siblings('.material-box-description').height();
            $(this).siblings('.material-box-description').css('height', 'auto');
            var autoHeight = $(this).siblings('.material-box-description').height();
            $(this).siblings('.material-box-description').height(curHeight as number).animate({height:autoHeight},200);
            $(this).html('Weniger lesen');
        } else {
            $(this).siblings('.material-box-description').removeClass('material-box-description-big');
            $(this).siblings('.material-box-description').animate({height:176},200);
            $(this).html('Mehr lesen');
        }
    });
}
const isOverflown = (element: Element) => {
    return element.scrollHeight > element.clientHeight+10 || element.scrollWidth > element.clientWidth+10;
}

document.addEventListener('DOMContentLoaded', () => {
    materialSelectionHandling();
    descriptionOverflowHandling();

    const materialOrderForm = document.querySelector('[id^="addressForm_kundenclubBestellung"]') as HTMLFormElement | null;
    if (materialOrderForm) {
        const genderField = materialOrderForm.querySelector('select[name$="[singleselect-1]"]') as HTMLSelectElement | null;
        const firstNameField = materialOrderForm.querySelector('input[name$="[text-2]"]') as HTMLInputElement | null;
        const lastNameField = materialOrderForm.querySelector('input[name$="[text-3]"]') as HTMLInputElement | null;
        const companyField = materialOrderForm.querySelector('input[name$="[text-1]"]') as HTMLInputElement | null;
        const emailField = materialOrderForm.querySelector('input[name$="[email-1]"]') as HTMLInputElement | null;
        const streetField = materialOrderForm.querySelector('input[name$="[text-9]"]') as HTMLInputElement | null;
        const houseNumberField = materialOrderForm.querySelector('input[name$="[text-10]"]') as HTMLInputElement | null;
        const postalCodeField = materialOrderForm.querySelector('input[name$="[text-11]"]') as HTMLInputElement | null;
        const cityField = materialOrderForm.querySelector('input[name$="[text-12]"]') as HTMLInputElement | null;
        const countryField = materialOrderForm.querySelector('select[name$="[text-8]"]') as HTMLInputElement | null;
        const phoneField = materialOrderForm.querySelector('input[name$="[telephone-1]"]') as HTMLInputElement | null;
        fetch('/api/form-prefill', {
            method: 'GET',
            credentials: 'same-origin',
        }).then(response => {
            if (response.ok) {
                return response.json().then(data => {
                    if (genderField) {
                        if (data.gender === 0) {
                            // Check for option with value male, Mr, Mr., Herr
                            const maleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'male' || option.value.toLowerCase() === 'mr' || option.value.toLowerCase() === 'mr.' || option.value.toLowerCase() === 'herr';
                            })
                            if (maleOption) {
                                genderField.value = maleOption.value;
                            }
                        } else if (data.gender === 1) {
                            // Check for option with value female, Ms, Ms., Mrs, Mrs., Frau
                            const femaleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'female' || option.value.toLowerCase() === 'ms' || option.value.toLowerCase() === 'ms.' || option.value.toLowerCase() === 'mrs' || option.value.toLowerCase() === 'mrs.' || option.value.toLowerCase() === 'frau';
                            })
                            if (femaleOption) {
                                genderField.value = femaleOption.value;
                            }
                        }
                    }

                    if (firstNameField) {
                        firstNameField.value = data.firstName || '';
                    }

                    if (lastNameField) {
                        lastNameField.value = data.lastName || '';
                    }

                    if (companyField) {
                        companyField.value = data.company || '';
                    }

                    if (emailField) {
                        emailField.value = data.email || '';
                    }

                    if (streetField) {
                        streetField.value = data.street || '';
                    }

                    if (houseNumberField) {
                        houseNumberField.value = data.houseNumber || '';
                    }

                    if (postalCodeField) {
                        postalCodeField.value = data.postalCode || '';
                    }

                    if (cityField) {
                        cityField.value = data.city || '';
                    }

                    if (countryField) {
                        countryField.value = data.country || '';
                    }

                    if (phoneField) {
                        phoneField.value = data.phone || '';
                    }
                });
            }
        })
    }
})
